export const Ids = {
  SUPER_ADMIN: '00000000-0000-0000-0000-000000000006',
};
